<img [src]="getIconSource(status)" alt="Battery" id="battery-icon" />
